import React from "react";

import DictionaryEntry from "../atoms/dictionary-entry";
const helpers = require("../../helpers");

import "../../scss/molecules/_header-cta.scss";

import { Link } from "gatsby-plugin-intl";

class Approach extends React.Component {
  render() {
    return (
      <div className="header-cta">
        <ul className="header-cta-list">
          <li>
            <Link
              to={helpers.getTrailedUrl("/about-us/")}
              className="header-cta-link btn btn-secondary btn-pointless"
            >
              <span>
                <DictionaryEntry
                  dictionaryEdges={this.props.dictionaryEdges}
                  dictionaryKey="home-page.hero.about-us-cta"
                  language={this.props.language}
                />
              </span>
            </Link>
          </li>
          <li>
            <Link
              to={helpers.getTrailedUrl("/cases/")}
              className="header-cta-link btn btn-secondary btn-pointless"
            >
              <span>
                <DictionaryEntry
                  dictionaryEdges={this.props.dictionaryEdges}
                  dictionaryKey="home-page.hero.cases-cta"
                  language={this.props.language}
                />
              </span>
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default Approach;
